import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

/**
 * Async thunk to set user data.
 * This function is designed to accept user data as an argument and return it.
 * In a real-world scenario, this could be used to fetch user data from an API.
 */
export const get_user_data = createAsyncThunk('user_data', async (data) => {
  return data;
});

/**
 * Async thunk to log out the user.
 * This function open the log out modal.
 */

export const set_open_log_out = createAsyncThunk(
  'set_open_log_out',
  async (data) => {
    return data;
  }
);
export const set_open_log_in = createAsyncThunk(
  'set_open_log_in',
  async (data) => {
    return data;
  }
);

/**
 * Initial state for the user slice.
 * - `user_data`: Stores the complete user information.
 * - `token`: Holds the authentication token.
 * - `user_name`: Stores the user's name.
 * - `user_email`: Stores the user's email.
 * - `mobile`: Stores the user's phone number.
 * - `role`: Stores the user's role.
 */
const initialState = {
  user_data: {},
  token: '',
  user_name: '',
  user_email: '',
  mobile: '',
  role: '',
  open_log_out: false,
  open_log_in: false,
};

/**
 * Redux slice to manage user-related state.
 * Uses `extraReducers` to handle actions related to the `get_user_data` async thunk.
 */
const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  extraReducers: (builder) => {
    builder.addCase(get_user_data.fulfilled, (state, action) => {
      const data = action.payload;

      // Update state with user details from the payload
      state.user_data = data;
      state.token = data?.accessToken;
      state.user_name = data?.user?.name;
      state.user_email = data?.email;
      state.mobile = data?.phoneNumber;
      state.role = data?.role;
    });

    builder.addCase(set_open_log_out.fulfilled, (state, action) => {
      const data = action.payload;
      // Update state with user details from the payload
      state.open_log_out = data;
    });
    builder.addCase(set_open_log_in.fulfilled, (state, action) => {
      const data = action.payload;
      // Update state with user details from the payload
      state.open_log_in = data;
    });
  },
});

export default userSlice.reducer;
